// NotFoundPage.js
import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{textAlign:'center'}}>
      <h1>Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
